
import { JWTPayloadParser } from '@goldenfront/core/authentication';

export class CustomPayloadParser implements JWTPayloadParser {
  parsePayload(decodedAccessToken: any): Object {
    return decodedAccessToken;
  }
}
